import { render, staticRenderFns } from "./CountryFlagDisplay.vue?vue&type=template&id=bd1042a8&scoped=true"
import script from "./CountryFlagDisplay.vue?vue&type=script&lang=js"
export * from "./CountryFlagDisplay.vue?vue&type=script&lang=js"
import style0 from "./CountryFlagDisplay.vue?vue&type=style&index=0&id=bd1042a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1042a8",
  null
  
)

export default component.exports